module.exports = {
      id: "icon-card-chip-usage",
      viewBox: "0 0 33 25",
      url: __webpack_public_path__ + "../resources/views/web/layout/partials/svg-icons.blade.php#icon-card-chip",
      toString: function () {
        return this.url;
      }
    }